module.exports = __webpack_public_path__ + "img/client-ag-restaurants.dddea2d2.png";